const DEFAULT_API_URL = "/api";

export function getApiBaseUrl() {
  const configured = import.meta.env.VITE_API_URL;
  if (typeof configured === "string" && configured.trim().length > 0) {
    return configured.replace(/\/$/, "");
  }
  return DEFAULT_API_URL;
}
